import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SalesOrderFilter } from '@shared/entities/salesOrderFilter';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable, shareReplay, Subject, switchMap, take, tap } from 'rxjs';

const LOG_PREFIX = '[Api][SalesOrderFilters] ';

export interface SalesOrderFilterURL {
  keyword?: string;
  salesOrderNumber?: string;
  accountId?: string;
  accountName?: string;
  serialNumbers?: string;
  orderBy?: string;
  direction?: 'ASC' | 'DESC';
  locationId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SalesOrderFiltersService extends ApiService<SalesOrderFilter> {
  private _refresh$: Subject<boolean>;
  all$: Observable<SalesOrderFilter>;
  currentFilters: SalesOrderFilterURL = {};

  set filters(value: SalesOrderFilterURL) {
    this.currentFilters = value;
    this.refresh(true);
  }

  constructor(private activatedRoute: ActivatedRoute) {
    const masterUrl = '/sales-orders/filters';
    const detailUrl = '/sales-orders/filters';

    super(SalesOrderFilter, masterUrl, detailUrl);

    this._refresh$ = new BehaviorSubject<boolean>(true);

    this.all$ = this._refresh$.pipe(
      switchMap(() => {
        const { locationId } = this.activatedRoute.snapshot.queryParams;
        if (locationId) {
          this.setUrlParameter('locationId', locationId);
        }

        if (
          this.currentFilters.accountName !== undefined &&
          this.currentFilters.accountName !== null &&
          this.currentFilters.accountName !== ''
        ) {
          this.setUrlParameter('accountName', this.currentFilters.accountName);
        }

        return this.findOne('');
      }),
      tap({
        next: (result) => this.logger.debug(LOG_PREFIX + 'all$', result),
        error: (err) => this.logger.error(LOG_PREFIX + 'all$ error', err)
      }),
      shareReplay(1)
    );
  }

  refresh(value: boolean) {
    this.logger.debug(LOG_PREFIX + 'refresh');
    this._refresh$.next(value);

    return this.all$.pipe(take(1));
  }
}
